import { type FieldPath } from 'react-hook-form';
import { FormPriceField } from 'src/components/Forms/FormPriceField/form-price-field';
import type { PlansTabFormValues } from 'src/pages/Settings/memberships/components/plans-tab/types';

const PRICE_INTEGER_DIGITS_LIMIT = 6;
const PRICE_DECIMAL_DIGITS_LIMIT = 2;
const PRICE_PATTERN = new RegExp(
  `^\\d{1,${PRICE_INTEGER_DIGITS_LIMIT}}(\\.\\d{0,${PRICE_DECIMAL_DIGITS_LIMIT}})?$`,
);

type PlanPriceFieldProps = {
  name: FieldPath<PlansTabFormValues>;
  label: string;
  endAdornment: string;
  isRequired: boolean;
  disabled?: boolean;
};

export const PlanPriceField = ({
  name,
  label,
  endAdornment,
  isRequired,
  disabled = false,
}: PlanPriceFieldProps) => {
  return (
    <FormPriceField
      name={name}
      label={label}
      valueAs="string"
      required={isRequired ? `${label} is required` : false}
      rules={{
        validate: (value) => {
          const stringValue = typeof value === 'string' ? value : '';

          if (!stringValue) {
            return isRequired ? `${label} is required` : true;
          }

          if (!PRICE_PATTERN.test(stringValue)) {
            return `Enter a valid ${label.toLowerCase()} with up to ${PRICE_DECIMAL_DIGITS_LIMIT} decimals`;
          }

          const numericValue = Number(stringValue);

          if (Number.isNaN(numericValue) || numericValue < 0) {
            return `${label} must be a non-negative amount`;
          }

          return true;
        },
      }}
      variant="outlined"
      size="small"
      fullWidth
      disabled={disabled}
      placeholder="0.00"
      endAdornment={endAdornment}
      showErrorText
    />
  );
};

export default PlanPriceField;
